// extracted by mini-css-extract-plugin
export default {"name":"styles_name__3Jig7","userDetails":"styles_userDetails__x0Z7z"};